import React from "react";

import { Stack, Typography } from "@mui/joy";

import { useIsAdmin } from "../hooks/useIsAdmin";
import { tryParseJson } from "../util/dataUtil";

import { MarvinSenderRow } from "./MarvinSenderRow";
import { MessageProps } from "../shared/props";

const styles = {
    errorMessageAdminText: {
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        overflowX: "scroll",
        fontFamily: "monospace",
    },
};

export default function ErrorMessage(props: MessageProps) {
    const msg = props.message;
    const isMarvin = msg.user.name === "Marvin";

    const currentUserIsAdmin = useIsAdmin();

    const jsonParsed = tryParseJson(msg.message);
    const messageKey = "message-" + msg.id;
    const body = jsonParsed?.err ? JSON.stringify(jsonParsed?.err, null, 2) : msg.message;
    return (
        <Stack direction="column" key={messageKey} spacing={1}>
            {isMarvin && !props.singleMessageView && <MarvinSenderRow />}

            <Typography level="body-sm">
                {currentUserIsAdmin ? (
                    <Typography sx={styles.errorMessageAdminText}>
                        {body.replaceAll("\\n", "\n")}
                    </Typography>
                ) : (
                    <Typography>
                        Marvin got a bit confused and was not able to generate a response. Please
                        try again. We have been notified of the issue and are investigating.
                    </Typography>
                )}
            </Typography>
        </Stack>
    );
}
